module.exports = __webpack_public_path__ + "static/img/anxun4.c3916f92.png";